// Returns an array of maxLength (or less) page numbers
// where a 0 in the returned array denotes a gap in the series.
// Parameters:
//   totalPages:     total number of pages
//   page:           current page
//   maxLength:      maximum size of returned array
function getPageList(totalPages, page, maxLength) {
    if (maxLength < 5) throw "maxLength must be at least 5";

    function range(start, end) {
        return Array.from(Array(end - start + 1), (_, i) => i + start);
    }

    let sideWidth = maxLength < 9 ? 1 : 2;
    let leftWidth = (maxLength - sideWidth * 2 - 3) >> 1;
    let rightWidth = (maxLength - sideWidth * 2 - 2) >> 1;
    if (totalPages <= maxLength) {
        // no breaks in list
        return range(1, totalPages);
    }
    if (page <= maxLength - sideWidth - 1 - rightWidth) {
        // no break on left of page
        return range(1, maxLength - sideWidth - 1)
            .concat([0])
            .concat(range(totalPages - sideWidth + 1, totalPages));
    }
    if (page >= totalPages - sideWidth - 1 - rightWidth) {
        // no break on right of page
        return range(1, sideWidth)
            .concat([0])
            .concat(
                range(totalPages - sideWidth - 1 - rightWidth - leftWidth, totalPages)
            );
    }
    // Breaks on both sides
    return range(1, sideWidth)
        .concat([0])
        .concat(range(page - leftWidth, page + rightWidth))
        .concat([0])
        .concat(range(totalPages - sideWidth + 1, totalPages));
}
class JsPaginationController {

    constructor(selector, onPageSelected, totalPages = 10, maxLength = 9) {
        this.page = 1;
        this.totalPages = totalPages;
        this.maxLength = maxLength;

        this.onPageSelected = onPageSelected;

        let paginationElements = Array.from(document.querySelectorAll(selector)).filter(e => e.dataset.js && e.dataset.js == "true");

        if (paginationElements.length == 0) {
            throw "No JS controlled pagination found in document";
        }

        this.elements = paginationElements;
    }

    updateTotal(t) {
        this.totalPages = t;
        this.refresh();
    }

    /**
     * 
     * @param {HTMLElement} el 
     */
    _disableElement(el) {
        el.setAttribute("aria-disabled", "true");
        el.setAttribute("tabindex", -1);
    }

    /**
     * 
     * @param {HTMLElement} el 
     */
    _enableElement(el) {
        el.removeAttribute("aria-disabled");
        el.removeAttribute("tabindex");
    }

    _createNumberElement(num) {
        const li = document.createElement("li");
        li.classList.add("page-item");

        if (num == this.page) {
            li.setAttribute("aria-current", "page");
            li.classList.add("active");
        } else if (num == 0) {
            li.classList.add("disabled");
        }

        const btn = document.createElement("button");
        btn.classList.add("page-link");
        btn.setAttribute("data-page", num);

        if (num != 0) btn.setAttribute("aria-label", "Page number " + num);
        else this._disableElement(btn);

        btn.innerText = num == 0 ? "..." : num;
        li.appendChild(btn);
        return li;
    }

    /**
     * 
     * @param {HTMLElement} ele 
     */
    refreshPagination(ele) {
        let nums = getPageList(this.totalPages, this.page, this.maxLength);

        let currentNumbers = Array.from(ele.querySelectorAll("li:not([data-nav='true'])"));
        currentNumbers.forEach(e => ele.removeChild(e));

        // Prev and next should be the only two elements left after the purge above.

        const prev = ele.children[0].cloneNode(true);
        if (this.page == 1) {
            prev.classList.add("disabled");
            this._disableElement(prev.children[0]);
            prev.children[0].removeAttribute("data-page");
        } else {
            prev.classList.remove("disabled");
            this._enableElement(prev.children[0]);
            prev.children[0].setAttribute("data-page", this.page -1);
        }

        const next = ele.children[1].cloneNode(true);
        if (this.page == this.totalPages) {
            next.classList.add("disabled");
            this._disableElement(next.children[0]);
            next.children[0].removeAttribute("data-page");
        } else {
            next.classList.remove("disabled");
            this._enableElement(next.children[0]);
            next.children[0].setAttribute("data-page", this.page +1);
        }

        // Replace it
        ele.replaceChild(prev, ele.children[0]);
        ele.replaceChild(next, ele.children[1]);

        //ele.children[0].classList.toggle("disabled", this.page == 1);
        //ele.children[1].classList.toggle("disabled", this.page == this.totalPages);

        var eles = nums.map(num => this._createNumberElement(num));
        ele.children[0].after(...eles); // Insert all the number li's after the "prev" element

        // Attach the event handler
        Array.from(ele.children).forEach(e => {
            e.addEventListener("click", this._onPageClick.bind(this));
        });
    }

    updateOnPageSelect(f){
        this.onPageSelected = f;
    }

    async _onPageClick(event) {
        /** @type HTMLElement */
        const ele = event.target;

        const newPageNumber = ele.dataset.page;
        if(!newPageNumber){
            console.error("Cannot update page... No page number");
            return;
        }
        
        if(newPageNumber == this.page || newPageNumber < 0 || newPageNumber > this.totalPages){
            event.preventDefault();
            return;
        }

        const parentEle = ele.closest(".pagination[data-js='true']");

        await this.onPageSelected(newPageNumber, parentEle);
        this.page = Number(newPageNumber);
        this.refresh();
    }

    refresh() {
        this.elements.forEach(e => this.refreshPagination(e));
    }
}

export { JsPaginationController };